const version = {
  version: '1.11.0',
};

export default version;
